//lat: -0.2480777
//lng: -78.5262284
import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker} from 'google-maps-react';
import '../css/editLocation.css';
import 'whatwg-fetch';
class editLocation extends Component {
  constructor(props) {
    super(props);
    //this.mapRef = React.createRef();
    this.state = {
       name:this.props.name,
       referencia:'',
       markers: [
         {
           name: "Current position",
           position: {
             lat: this.props.lat,
             lng: this.props.lng
           }
         }
       ],
       mounted : false,
       mapStyles: [

     {
     "featureType": "administrative.neighborhood",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.man_made",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural.landcover",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural.terrain",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.attraction",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.business",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.government",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.medical",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.park",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.place_of_worship",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.school",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.sports_complex",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "road.highway",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "road.local",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "transit.station",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "water",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     }
     ]
     };
  }

  inputChangedHandlerText1 = (event) => {
    this.setState({
      name :event.target.value
    })
  }

  inputChangedHandlerText2 = (event) => {
    this.setState({
      referencia :event.target.value
    })
  }

  getaddAddress =()=>{
    const url= this.props.dir_url + "webapp/addNewUbication";
    const token =  this.props.token
    const token_Client = this.props.token_Client
    const lat = this.state.markers[0].position.lat
    const lng = this.state.markers[0].position.lng
    const referencia =this.state.referencia
    const calle=this.state.name
    //var data = {username: 'example'};
    var obj = { accion:'newubication', token, token_Client, lat, lng, referencia,calle};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.props.get_loading(false)
        this.props.get_finalice_to(lat,lng,calle,Number(data[0].msg))
      }
    })
    .catch(console.log)
    this.props.get_loading(true)
  }
  onMarkerDragEnd = (coord, index) => {
      const { latLng } = coord;
      const lat = latLng.lat();
      const lng = latLng.lng();

      this.setState(prevState => {
        /*const markers = [...this.state.markers]
        markers[index] = [...markers[index], { position: { lat, lng } }]
        return { markers }*/

        const markers = [...this.state.markers];
        markers[index] = { ...markers[index], position: { lat, lng } };
        return { markers };

      });
    };
    render() {
      //console.log(this.props.google)

      return (
        <div className="modal-dialog-new-ubication">
          <div className="modal-content-new-ubication">
            <div className="grid-container-menu-new-ubication">
              <div className="div_menu_1-new-ubication">
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') }
                onClick={ () => this.props.get_go_to('')} />
              </div>
              <div className="lbl_menu_2-new-ubication">
                <span className="span-global-link">Seleccione su Ubicación</span>
              </div>
            </div>
            <div className="grid-container-menu-new-ubication-map">
            <Map
            google={this.props.google}
            style={{
              width:"90%",
              height: "300px",
              left: "5px",
              right: "5px",
              position: 'relative'
            }}
            zoom={17}
            ref={this.mapRef}
            initialCenter={{ lat: this.props.lat, lng: this.props.lng }}
            disableDefaultUI ={true}
            styles={this.state.mapStyles}
            >
            {this.state.markers.map((marker, index) => (
              <Marker
                position={marker.position}
                draggable={true}
                onDragend={(t, map, coord) => this.onMarkerDragEnd(coord, index)}
                name={marker.name}
                key={index}
              />
            ))}
            </Map>
            </div>
            <div className="grid-container-menu-new-ubication">
              <div className="div_menu_1-new-ubication">
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }
                onClick={ () => this.props.get_go_to('')} />
              </div>
              <div className="lbl_menu_2-new-ubication">
                <input style={{width:"80%"}} className="input-global"
                placeholder="Direccion" value={this.state.name} onChange={(event)=>this.inputChangedHandlerText1(event)} />
              </div>
            </div>
            <div className="grid-container-menu-new-ubication">
              <div className="div_menu_1-new-ubication">
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/2198796101582004488-128.png') }
                onClick={ () => this.props.get_go_to('')} />
              </div>
              <div className="lbl_menu_2-new-ubication">
                <input style={{width:"80%"}} className="input-global"
                 placeholder="Referencia" value={this.state.referencia} onChange={(event)=>this.inputChangedHandlerText2(event)} />
              </div>
            </div>
            <div className="grid-container-menu-new-ubication-map">
              <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getaddAddress()}>
              LISTO
              </button>
            </div>
          </div>
        </div>
    )
    }
    componentDidMount (){
/*var anchors = document.getElementsByTagName('a'),
    l = anchors.length,
    i,
    a;

for (i = 0; i < l; i++) {
    a = anchors[i];
    if (a.href.indexOf('maps.google.com/maps?') !== -1) {
         a.title = '';
         a.onclick = function () { return false; };
    }
}*/
    }

}
export default GoogleApiWrapper({
  apiKey: 'AIzaSyAtyO9FEIXPiDDSLE1a88MNGVpLKgxnxqo'
})(editLocation);
